import React from 'react';

import SolutionsHSPage from './SolutionsHSPage';
import SolutionsMSPage from './SolutionsMSPage';
import SolutionsESPage from './SolutionsESPage';

import '../../css/home_page.css';

export default function SolutionsPage(props) {
	const school_type = props.match.params.school_type;
	
	return (
		<>
		{(school_type === 'highschools') ?
			(
				<SolutionsHSPage></SolutionsHSPage>
			): (school_type === 'middleschools') ? 
			(
				<SolutionsMSPage></SolutionsMSPage>
			):(school_type === 'elementaryschools') ? (
				<SolutionsESPage></SolutionsESPage>
			):null	
		}
		</>
		
	);
}